import React from "react";

import { Card } from "@swa-ui/core";

import { VacationsBookingFormWide } from "../VacationsBookingForm";
import styles from "./VacationsBookingWidget.module.scss";

export const VacationsBookingWidget = () => (
  <Card fullHeightContent={true}>
    <div className={styles.widget}>
      <VacationsBookingFormWide />
    </div>
  </Card>
);
